import { motion } from "framer-motion";
import { ONE_VISION } from "../../data/homeContent";

const ASPECTS = ["4/5", "4/3", "3/4", "4/5", "4/3", "3/4", "4/5"];

// 1.11 — One Vision. Many Expressions.
// Seven conceptual blocks (not clickable doorways) distributed across three
// staggered columns for the collage rhythm: col 0 → [0,3,6], col 1 → [1,4], col 2 → [2,5].
const COLS = [
  [0, 3, 6],
  [1, 4],
  [2, 5],
];

const Card = ({ i, delay, fromX = 120, fromY = 30 }) => {
  const c = ONE_VISION.blocks[i];
  return (
    <motion.div
      data-testid={`vision-card-${i}`}
      initial={{ opacity: 0, x: fromX, y: fromY, scale: 0.9 }}
      whileInView={{ opacity: 1, x: 0, y: 0, scale: 1 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
      className="group rounded-2xl overflow-hidden bg-[#0C1220] ring-1 ring-[#C9A24B]/15 shadow-[0_24px_60px_-30px_rgba(0,0,0,0.9)] hover:ring-[#C9A24B]/45 transition-all"
    >
      <div className="overflow-hidden" style={{ aspectRatio: ASPECTS[i] }}>
        <img
          src={c.img}
          alt={c.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
      </div>
      <div className="px-4 py-4">
        <p className="text-[11px] tracking-[0.24em] uppercase text-[#E7CC86]/75">{c.label}</p>
        <p className="font-display text-lg text-cream leading-tight mt-1">{c.title}</p>
        <p className="text-cream/55 text-sm mt-1.5 leading-snug">{c.line}</p>
      </div>
    </motion.div>
  );
};

export const EcosystemShowcase = () => {
  return (
    <section id="ecosystem-story" data-testid="eco-scroll-story" className="relative py-24 md:py-32 overflow-hidden grain">
      <div className="aurora-weave slow" />
      <div className="line-weave" />
      <div className="absolute -top-24 left-0 w-[40rem] h-[40rem] radial-glow blur-3xl pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 flex flex-col md:flex-row gap-12 md:gap-14 md:items-center">
        {/* Left — heading pinned */}
        <motion.div
          initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
          className="md:w-[36%] shrink-0"
        >
          <p className="text-xs md:text-sm tracking-[0.32em] uppercase text-[#E7CC86]/75 mb-6">{ONE_VISION.eyebrow}</p>
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-cream">
            {ONE_VISION.h}<br />
            <span className="text-gold">{ONE_VISION.hGold}</span>
          </h2>
          <p className="mt-6 text-base md:text-lg text-cream/60 max-w-md">
            {ONE_VISION.sub}
          </p>
        </motion.div>

        {/* Right — staggered collage (desktop) */}
        <div className="hidden md:flex flex-1 gap-4">
          {COLS.map((col, ci) => (
            <div key={ci} className={`flex-1 flex flex-col gap-4 ${ci === 1 ? "mt-10" : ci === 2 ? "mt-20" : ""}`}>
              {col.map((i, k) => (
                <Card key={i} i={i} delay={0.07 * k} fromX={110} fromY={30} />
              ))}
            </div>
          ))}
        </div>

        {/* Right — 2-col grid (mobile) */}
        <div className="md:hidden grid grid-cols-2 gap-3">
          {ONE_VISION.blocks.map((_, i) => (
            <Card key={i} i={i} delay={0.05 * i} fromX={i % 2 ? 80 : -80} fromY={40} />
          ))}
        </div>
      </div>
    </section>
  );
};
